export const techPayCardTitle = 'Technician pay';
export const techPayCardBase = 'Base: $30';
export const removePackageTitle = 'Are you sure you want to remove this partner package?';
export const removePackageButton = 'remove';
export const removePackageSuccess = 'You have successfully removed the partner package.';
